module.exports = __webpack_public_path__ + "static/media/light-r-7.7e26daba.png";